export function getReadonlyWarning(data) {
    const { isPreview, isSampleRelationship } = data;
    if (isSampleRelationship) {
        return 'It is not possible to set a payment method in test agreement';
    }
    if (isPreview) {
        return 'It is not possible to set a payment method in preview mode';
    }
    return null;
}
